<nz-select #selector [nzMaxMultipleCount]="5" class="report-select" nzMode="multiple" nzPlaceHolder="Please select"
    nzShowSearch nzServerSearch [nzFilterOption]="nzFilterOption"
    [(ngModel)]="value" (nzOnSearch)="search($event)" (nzOpenChange)="search('')" (ngModelChange)="valueChanged($event)"
    (nzScrollToBottom)="loadMore()"
    name="locations" [nzAutoClearSearchValue] nzAllowClear [nzDropdownRender]="loadingTpl" style="width: 400px;">

    <nz-option [nzValue]="null" [nzLabel]="'Non-Location'" nzCustomContent>
        <div class="dropdown-container">
            <strong>Non-Location</strong>
        </div>
    </nz-option>

    <ng-container *ngFor="let o of locationList">
        <nz-option [nzValue]="o.code" [nzLabel]="o.code" nzCustomContent>
            <div class="dropdown-container">
                <strong>{{ o.code }}</strong>
                <span *ngIf="o.name && o.name.trim() !== ''"> : </span>
                <span> {{ o.name }}</span>
            </div>
        </nz-option>
    </ng-container>

</nz-select>

<ng-template #loadingTpl>
    <div *ngIf="searching">
        <nz-spin></nz-spin>
        Loading
    </div>
</ng-template>